import PageHeader from "./PageHeader";
import Header from "./Header";
import Subheader from "./Subheader";
import Divider from "./Divider";
export { PageHeader as default, Header, Subheader, Divider };
